import clsx from 'clsx';
import React from 'react';
import { Label } from '../Label/Label';
import styles from './Switch.module.scss';

type SwitchProps = Omit<React.ComponentProps<'input'>, 'onChange'> & {
    label?: string;
    inlineLabel?: string;
    onChange?: (checked: boolean) => void;
};

export const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
    ({ label, inlineLabel, className, ...inputProps }, ref) => {
        return (
            <div className={clsx(styles.root, className)}>
                {label && <Label>{label}</Label>}

                <div className={styles.switchContainer}>
                    {inlineLabel && <span className={styles.inlineLabel}>{inlineLabel}</span>}

                    <div
                        className={clsx(styles.switch, {
                            [styles.checked]: inputProps.checked,
                            [styles.disabled]: inputProps.disabled
                        })}
                    >
                        <span
                            className={clsx(styles.slide, {
                                [styles.slideChecked]: inputProps.checked
                            })}
                        ></span>
                        <input
                            ref={ref}
                            {...inputProps}
                            className={styles.input}
                            onChange={event => inputProps.onChange?.(event.target.checked)}
                            type="checkbox"
                        />
                    </div>
                </div>
            </div>
        );
    }
);

Switch.displayName = 'Switch';
